// Import-free by design: `errors.ts` classifies this on the mic, connectivity and
// chunk paths, so declaring it beside the fence would drag broadcast-channel, uuid
// and the logger facade into every one of their bundles.

/**
 * Raised when memory-only mode refuses a persistence write. Deliberately not a
 * `WriteFenceStaleError`: the ledger tolerates this one and keeps the mirrored
 * row, where a stale-fence error leaves nothing uploadable.
 */
export class MemoryOnlyWriteError extends Error {
  constructor() {
    super('audio write fence: memory-only (store could not be cleared)');
    this.name = 'MemoryOnlyWriteError';
  }
}

// Name-based like its stale-fence sibling: instanceof does not survive a
// realm boundary, and a false negative here retries a doomed write.
export const isMemoryOnlyWriteError = (err: unknown): boolean =>
  err instanceof Error && err.name === 'MemoryOnlyWriteError';
